// @ts-nocheck

import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"

//@ts-ignore
import cellEditFactory from "react-bootstrap-table2-editor"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"

import { Col, Row, Button } from "reactstrap"

interface Props {
	colaboradores: Array<any>
	columnsColaboradores: any
	unidade: any
	valor: any
	somaValorColaboradores: any
	beforeSaveCellColaborador: Function
	handleRedistruibuirPorColaboradores: Function
}

const TableColaboradores: React.FC<Props> = ({
	colaboradores,
	columnsColaboradores,
	unidade,
	valor,
	somaValorColaboradores,
	beforeSaveCellColaborador,
	handleRedistruibuirPorColaboradores,
}) => {
	const [data, setData] = useState([]) //Lista para receber produtos adicionados
	const [reload, setReload] = useState(false)

	useEffect(() => {
		console.log("####### USE EFFECT EM TABLECOLABORADORES da LISTA COLABORADOR ########")
		console.log(reload)
		setData([])
		//@ts-ignore
		//setData(colaboradores)
		if (colaboradores && colaboradores.length > 0) {
			setReload(true)
		} else {
			//@ts-ignore
			setData(colaboradores)
			setReload(false)
		}
	}, [colaboradores])

	useEffect(() => {
		console.log("####### USE EFFECT RELOAD TABELA COLABORADOR ########")
		console.log(reload)
		if (reload) {
			//@ts-ignore
			setData(colaboradores)
			setReload(false)
		}
	}, [reload])

	return (
		<>
			<Row>
				<Col className="col-12">
					<ToolkitProvider
						//data={meta ? (meta.produtos ? meta.produtos : []) : []}
						data={data ? data : []}
						keyField="user_id"
						//@ts-ignore
						columns={columnsColaboradores}
					>
						{(props) => (
							<div className="table-responsive py-4">
								<BootstrapTable
									{...props.baseProps}
									noDataIndication={() => (
										<span>Nenhum colaborador adicionado</span>
									)}
									bootstrap4={true}
									bordered={false}
									cellEdit={cellEditFactory({
										mode: "click",
										blurToSave: true,
										beforeSaveCell: beforeSaveCellColaborador,
									})}
								/>
							</div>
						)}
					</ToolkitProvider>
				</Col>
			</Row>
			<div>
				{unidade && unidade == "M"
					? `Soma parcial: R$ ${parseFloat(somaValorColaboradores).toFixed(
							2
					  )}  /  Saldo: R$ ${
							valor
								? parseFloat((valor - somaValorColaboradores).toFixed(2)).toFixed(2)
								: parseFloat((0 - somaValorColaboradores).toFixed(2)).toFixed(2)
					  }`
					: //@ts-ignore
					  `Soma parcial: ${parseInt(somaValorColaboradores)}  /  Saldo: ${
							valor
								? parseInt(valor - somaValorColaboradores)
								: parseInt(0 - somaValorColaboradores)
					  }`}

				{/* <Button
          color="primary"
          type="button"
          outline
          //@ts-ignore
          onClick={handleRedistruibuirPorProdutos}
          className="btn-icon btn-3 btn-sm"
          title='Redistribuir Meta por Produtos Automaticamente'
          style={{ marginLeft: 15 }}
          disabled={!(produtos && produtos.length > 0)}
        >
          <span className="btn-inner--icon">
            <i className="fas fa-divide"></i>
          </span>
          <span className="btn-inner--text">Redistribuição</span>
        </Button> */}
			</div>
		</>
	)
}

export default TableColaboradores
